import React from 'react';

import Alert from './alert.svg?react';

function AlertIcon({ size }: { size: number }) {
  return <Alert width={size} height={size} />;
}

export default AlertIcon;
